import React, { useState, useRef, useMemo } from 'react'
import CreatableSelect from 'react-select/creatable'
import styles from '../../styles.module.scss'

import {
  Tabs,
  Tab
} from 'react-bootstrap'

import {
  LevelsIcon,
  BrowserIcon,
  StartSolidRoundedIcon
} from '../../../../_components/Icons'

import {
  Switch,
  MediaImage,
  NotificationLinuxExample,
  NotificationAndroidExample,
  NotificationWindowsExample,
  NotificationIosExample,
  NotificationOsxExample
} from '../../../../_components'

import {
  handleTestNotification
} from '../../../../_helpers'

export const notificationIntervalRecurrency = {
  "A": 31536000,
  "M": 2592000,
  "D": 86400,
  "h": 3600,
  "m": 60,
  "s": 1
}

export default function Notification({localData, setLocalData, handleChange, errors, setErrors}) {
  const dataDispatcher = useMemo( () => {
    const filter = ( localData.momentums ?? [] ).find( ( { type } ) => type === 'dispatcher' )
    return filter?.values?.[0]
  }, [ localData ] )

  const firstDataDispatcher = useRef( dataDispatcher )
  const [ recurrence, setRecurrence ] = useState( !!firstDataDispatcher.current?.intervalRecurrency?.length )

  const title = useRef()
  const message = useRef()

  const handleIntervalRecurrency = (e, type) => {
    const arr = localData.dispatcher || []
    const raw = `raw_${type}`

    if ( !e || !type ) {
      delete arr.intervalRecurrency
      delete localData.raw_intervalRecurrency
      return setLocalData({...localData, dispatcher: arr}, {[raw]: []})
    }

    const values = e.map(({value}) => {
      const multi = notificationIntervalRecurrency

      const regex = value.match(/[a-z]+|[^a-z]+/gi);
      const multiValue = regex[0];
      const multiplier = multi[regex[1]];
      const totalSeconds = multiplier * multiValue;

      if ( !multiplier ) return undefined

      return totalSeconds
    })

    setLocalData({...localData, dispatcher: {...arr, [type]: values}, [raw]: e})
  }

  return (<>
    <div className="flex__break"></div>
    <div className={styles["card__sub-body"]}>
      <div className={`${styles['title__group']} ${styles['title__group--noicon']}`}>
        <h4>Notificação recorrente?</h4>
        <span className="help" data-help="Define se a mesma notificação será enviada mais de uma única vez para os usuários em intervalos de tempo pré-definidos.">?</span>

        <Switch
          checked={recurrence}
          onChange={() => setRecurrence(recurrence => !recurrence)}
        />
      </div>
    </div>

    {
      recurrence && <>
        <div className={styles["card__sub-body"]}>
          <div className="flex">
            <CreatableSelect
              className={`selectable ${styles['selectable__interval']}`}
              value={localData.raw_intervalRecurrency}
              isClearable
              isMulti
              placeholder="Defina a recorrência da notificação. Exemplo: 2h 3m 10s"
              components={{DropdownIndicator: null}}
              noOptionsMessage={() => "D = Dia | h = hora | m = minuto | s = segundos"}
              formatCreateLabel={(inputValue) => `Adicionar recorrência de: ${inputValue}`}
              onChange={(e) => handleIntervalRecurrency(e, 'intervalRecurrency')}
            />
          </div>
        </div>
        <div className="flex__break"></div>
      </>
    }

    <div className={styles["card__sub-body"]}>
      <div className="flex">
        <div className="w-full" style={{maxWidth: "50%"}}>
          <div className={styles['title__group']}>
            <LevelsIcon />
            <h4>Customizar mensagem</h4>
          </div>

          <div className={`${styles['content__wrapper']} ${styles['content__wrapper--epr']}`}>
            <MediaImage
              title="Adicionar ícone da notificação"
              description="Tamanho recomendado 100x100px"
              image={localData.dispatcher?.icon_uri}
              type="icon_uri"
              onChange={handleChange}
            />

            <div className={`${styles['input__group']} ${styles['input__group--emb']}`}>
              <span
                className={styles['input__text-limit']}
                style={{width: (100/49 * (title.current ? title.current.value.length : 0)) + '%'}}
              ></span>
              <div
                className={`
                  inputable__wrapper
                  ${errors.dispatchertitle ? "inputable__wrapper--error" : ""}
                `}
              >
                <input type="text" className="inputable" placeholder="Título" ref={title}
                  value={localData.raw_title?.value}
                  onChange={e => handleChange(e.target, 'title')} maxLength="49"/>
              </div>
              <span>{title.current ? title.current.value.length : 0}/49</span>
            </div>

            <div className={`${styles['input__group']} ${styles['input__group--emb']}`} data-text-size={message.current ? message.current.value.length : 0}>
              <span
                className={styles['input__text-limit']}
                style={{bottom: "3px", width: (100/126 * (message.current ? message.current.value.length : 0)) + '%'}}
              ></span>
              <div
                className={`
                  inputable__wrapper
                  ${errors.dispatchermessage ? "inputable__wrapper--error" : ""}
                `}
              >
                <textarea className="inputable" placeholder="Mensagem" ref={message} value={localData.raw_message?.value} onChange={e => handleChange(e.target, 'message')}maxLength="126"/>
              </div>
              <span>{message.current ? message.current.value.length : 0}/126</span>
            </div>

            <div className={styles["input__group"]}>
              <div
                className={`
                  inputable__wrapper
                  ${errors.redirectUri ? "inputable__wrapper--error" : ""}
                  ${errors.redirectUri === "urlError" ? "inputable__wrapper--error inputable__wrapper--error-url" : ""}
                `}
              >
                <input type="text" className="inputable" placeholder="URL de redirecionamento" value={localData.raw_redirect_uri?.value} onChange={e => handleChange(e.target, 'redirect_uri')}/>
              </div>
            </div>

            <MediaImage
              title="Adicionar imagem grande"
              description="Tamanho recomendado 1000x500px"
              image={localData.dispatcher?.image}
              type="image"
              onChange={handleChange}
            />

            {
              ("Notification" in window) ? 
                <button
                  type="button"
                  className="button button__with-icon button--blue"
                  onClick={() => {
                    handleTestNotification(
                      localData.dispatcher && localData.dispatcher.title,
                      localData.dispatcher && localData.dispatcher.message,
                      localData.dispatcher && localData.dispatcher.image,
                      localData.dispatcher && localData.dispatcher.icon_uri,
                      localData.dispatcher && localData.dispatcher.redirect_uri
                    )
                  }}>
                  <StartSolidRoundedIcon />
                  <span>Testar notificação</span>
                </button>
              : null
            }
          </div>
        </div>

        <div className="w-full" style={{maxWidth: "50%"}}>
          <div className={styles['title__group']}>
            <BrowserIcon />
            <h4>Pré-visualização</h4>
          </div>

          <div className={styles['content__wrapper']}>
            <div className={styles['content__wrapper__examples']}>
              <Tabs defaultActiveKey="windows">
                <Tab tabClassName={styles['content__tabs']} eventKey="windows" title="Windows">
                  <NotificationWindowsExample data={localData.dispatcher && localData.dispatcher}/>
                </Tab>
                <Tab tabClassName={styles['content__tabs']} eventKey="osx" title="OSx">
                  <NotificationOsxExample data={localData.dispatcher && localData.dispatcher}/>
                </Tab>
                <Tab tabClassName={styles['content__tabs']} eventKey="linux" title="Linux">
                  <NotificationLinuxExample data={localData.dispatcher && localData.dispatcher}/>
                </Tab>
                <Tab tabClassName={styles['content__tabs']} eventKey="ios" title="iOS">
                  <NotificationIosExample data={localData.dispatcher && localData.dispatcher}/>
                </Tab>
                <Tab tabClassName={styles['content__tabs']} eventKey="android" title="Android">
                  <NotificationAndroidExample data={localData.dispatcher && localData.dispatcher}/>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>)
}